module.exports = __webpack_public_path__ + "img/_info-icon.161fdc62.svg";